import { Component } from '@angular/core';
import { DataService } from './../../../services/data/data.service';
import { FuncionesMes, formatear, periodos } from './../../funciones/funcionesGenerales';
import { environment } from './../../../../environments/environment'
import { CuentaEntity, EvaluacionEntity } from './../../funciones/AlertaTemprana';
import { getEvaluaciones, getDetalleEvaluacionCuenta, getCuentas, getDetalleEvaluacionVariables, getVariables, getDetalleEvaluacionVariableTem, getVariableTem } from './../../../services/financiero/catalogo-cuentas/querys'
import { Apollo } from 'apollo-angular';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ExcelService } from './../../../services/excel/excel.service';
import moment from 'moment';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';
import { FiltersM } from '../../../components/models';
import { companiesFinanciero } from '../../../shared/catalogos';
import { obtenerCodigoPropio } from '../idsTablas';

@Component({
  selector: 'app-catalogo-cuentas',
  templateUrl: './catalogo-cuentas.component.html',
  styleUrl: './catalogo-cuentas.component.css'
})
export class CatalogoCuentasComponent {
  public Filters = FiltersM;
  //Consulta
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  //Variables para alerta temprana
  private cuentaEntity = new CuentaEntity;
  private evaluacionEntity = new EvaluacionEntity;
  /* Variables tablero */
  //Variables filtros
  public Periodos = [];
  private maxPeriodos = 6;
  private periodosSeleccionados = 0;
  //Variables tablas
  public subTitles = [];
  public cadenaEvaluacion = [];
  public tituloTabla = '';
  public dataOrdenado = [];
  public dataOrdenado2 = [];
  public cuentas = true;

  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';

  //Variables de personalizacion
  public multiMoneda: boolean;
  public codigoPropio: boolean;

  constructor(
    public dataService: DataService,
    private apollo: Apollo,
    private translate: TranslateService,
    private cookieService: CookieService,
    private excelService: ExcelService,
  ) {
    this.cuentaEntity = new CuentaEntity;
    this.evaluacionEntity = new EvaluacionEntity;
    this.evaluacionEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    this.cuentaEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.personalizacion();
    this.getEvaluacion();
  }
  ngOnInit(): void {}
  private personalizacion(){
    const settings = companiesFinanciero.find(i => i.id == this.evaluacionEntity.Id_Institucion+'');
    this.multiMoneda = settings.multiMoneda;
    this.codigoPropio = settings.codigoPropio;
  }
  /* formateo de datos */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  /* Consultas */
  private async getEvaluacion(){
    try{
      const data = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla }
        }).valueChanges.source
      );

      var aux = [];
      for(const per of data.data.evaluaciones){
        if(per.idInstitucion === this.evaluacionEntity.Id_Institucion){
          aux.push(per);
        }
      }
      this.ordenamientoDataEvaluacion(aux);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getDetalleEvaluacion(){
    try{
      var i=0;
      let datos = [];
      for(const eva of this.cadenaEvaluacion){
        const {data} = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleEvaluacionCuenta,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id}
          }).valueChanges.source
        );

        var aux = [];
        for(const d of data.detalleEvaluacionCuentas){
          aux.push({
            per: eva.evaluacion,
            ...d
          });
        }
        datos = datos.concat(aux)
      }
      this.getCuentas(datos);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getCuentas(array){
    try{
      const {data} = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getCuentas,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla}
        }).valueChanges.source
      ); 

      let datos = data.cuentas;
      let aux = [];
      var levels = [], lngLevels = [], level = 0;
    
      for(const cuenta of datos){
        let valores = array.filter(eva => eva.idCuenta === cuenta.id);

        valores.sort(function (a, b) {
          if ( moment(FuncionesMes.escrituraPer(a.per)).isAfter(moment(FuncionesMes.escrituraPer(b.per))) ) {
            return 1;
          }
          if ( moment(FuncionesMes.escrituraPer(a.per)).isBefore(moment(FuncionesMes.escrituraPer(b.per))) ) {
            return -1;
          }
          return 0;
        });

        const ex = lngLevels.indexOf(cuenta.id.length);
        if(ex === -1){
          levels.push(levels.length+1);
          lngLevels.push(cuenta.id.length);
          level = levels.length;
        }else{
          level = levels[ex];
        }
        var config = obtenerCodigoPropio.idsCodigoPropio(this.evaluacionEntity.Id_Plantilla, cuenta.id);
        aux.push({
          id: cuenta.id,
          codigo: config?.codigo,
          descripcion: this.capitalizacionTexto(cuenta.descripcion),
          series: valores,
          nivel: level,
          check: level===1||level===2?true:false,
          dbCheck: level===1?true:false,
          moneda: config?.moneda
        });
      }

      const cat = aux.filter( inf => inf.id.length === 2);

      let aux2 = [];

      for(const c of cat){
        const elem = aux.filter( inf => inf.id.includes(c.id));
        aux2.push({
          id: c.id,
          nom:  c.descripcion,
          val: elem
        })
      }


      aux2.sort(function (a, b) {
        if ( Number(a.id.substring(1)) > Number(b.id.substring(1)) ) {
          return 1;
        }
        if ( Number(a.id.substring(1)) < Number(b.id.substring(1)) ) {
          return -1;
        }
        return 0;
      });

      aux = [];

      for(const v of aux2){
        aux = aux.concat(v.val);
      }

      this.dataOrdenado = aux;

      this.getDetalleEvaluacionVariables();

    }catch(err){
      messages.errorMessageGraph(this.translate)
    }
  }
  private async getDetalleEvaluacionVariables(){
    try{
      let datos = [];
      for(const eva of this.cadenaEvaluacion){
        const {data} = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleEvaluacionVariables,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id}
          }).valueChanges
        );
        var aux = [];
        for(const d of data.detalleEvaluacionVariables){
          aux.push({
            per: eva.evaluacion,
            ...d
          });
        }
        datos = datos.concat(aux)
      } 
      this.getVariables(datos);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getVariables(array){
    try{

      const {data} = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVariables,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla}
        }).valueChanges.source
      );
      let datos = data.variables.filter(d => d.idPlantilla === this.cuentaEntity.Id_Plantilla);
      let aux = [];
      for(const cuenta of datos){
        let valores = array.filter(eva => eva.idVariable === cuenta.id);

        valores.sort(function (a, b) {
          if ( moment(FuncionesMes.escrituraPer(a.per)).isAfter(moment(FuncionesMes.escrituraPer(b.per))) ) {
            return 1;
          }
          if ( moment(FuncionesMes.escrituraPer(a.per)).isBefore(moment(FuncionesMes.escrituraPer(b.per))) ) {
            return -1;
          }
          return 0;
        });

        aux.push({
          id: cuenta.id,
          descripcion: this.capitalizacionTexto(cuenta.descripcion),
          series: valores,
          nivel: 2,
          check: true,
          dbCheck: false,
        });
      }
      aux = this.ordenarArray(aux);
      
      this.dataOrdenado2 = aux;
      this.getDetalleEvaluacionVariablesTem();
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getDetalleEvaluacionVariablesTem(){
    try{
      let datos = [];
      for(const eva of this.cadenaEvaluacion){
        const { data } = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleEvaluacionVariableTem,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id}
          }).valueChanges.source
        );
        datos = datos.concat(data.detalleEvaluacionVarsTemps)
      }
      this.getVariablesTem(datos);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getVariablesTem(array){
    try{
      const {data} = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVariableTem,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.cuentaEntity.Id_Plantilla}
        }).valueChanges.source
      );
      let datos = data.varsTemp.filter(d => d.idPlantilla === this.cuentaEntity.Id_Plantilla);
      let aux = [];
      for(const cuenta of datos){
        let valores = array.filter(eva => eva.idVarTemp === cuenta.id);

        valores.sort(function (a, b) {
          if (a.idEvaluacion > b.idEvaluacion) {
            return 1;
          }
          if (a.idEvaluacion < b.idEvaluacion) {
            return -1;
          }
          return 0;
        });

        if(valores.length > 0){
          var config = obtenerCodigoPropio.idsCodigoPropio(this.evaluacionEntity.Id_Plantilla, cuenta.id);
          aux.push({
            id: cuenta.id,
            codigo: config?.codigo,
            descripcion: this.capitalizacionTexto(cuenta.descripcion),
            series: valores,
            nivel: 2,
            check: true,
            dbCheck: false,
            moneda: config?.moneda
          });
        }
      }
      
      aux = this.ordenarArray(aux);

      this.dataOrdenado2 = this.dataOrdenado2.concat(aux);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  /* */
  private ordenarArray(array){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) < Number(b.id)) {
        return 1;
      }
      if (Number(a.id) > Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  /* Obtención de datos */
  private ordenamientoDataEvaluacion(datos){
    this.tituloTabla = 'financiero.catalogoCuentas.tituloTabla3';
    const info = periodos.obtenerPeriodos(datos, this.maxPeriodos);
    this.Periodos = info.periodos;
    for(const an of this.Periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.periodosSeleccionados = info.perSel;
    this.ultimasEvaluaciones();
  }
  /* Ordenamiento */
  private ultimasEvaluaciones(){
    this.cadenaEvaluacion = [];
    this.subTitles = [];
    this.periodosSeleccionados = 0;
    var i=0, cadena = '';
    for(const an of this.Periodos){
      if(an.utilizable){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
    }
    this.getDetalleEvaluacion();    
  }
  /* Obtención de periodos */
  public cambioPeriodo(per){
    if( per.check || (!per.check && this.periodosSeleccionadosAct() < this.maxPeriodos ) ){
      per.check = !per.check;
      this.cadenaEvaluacion = [];
      this.subTitles = [];
      this.periodosSeleccionados = 0;
      var i=0, cadena = '';
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
      this.getDetalleEvaluacion();
    }else{
      document.getElementById("check_"+per.mes+""+per.anio)['checked'] = false;
      messages.messageGraph(
        'No se pueden seleccionar mas de '+this.maxPeriodos+' periodos',
        this.translate.instant(''),
        this.translate
      );
    }
  }
  private periodosSeleccionadosAct(){
    var sel = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          sel++;
        }
      }
    }
    return sel;
  }
  public numPerSelect(){
    var selecc = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          selecc++;
        }
      }
    }
    if(selecc > 1)
      return true;
    return false;
  }
  /* formateo de datos */
  public formatingAxis(valor){
    return formatear.retornarformatolefty(valor);
  }
  public escrituraPer(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  /* Pintado de la tabla */
  public fontRowBalance(lengthId){
    if(lengthId === 2)
      return 'w3-elemento-titulo-tableBalance w3-encabezado-balance';

    return 'w3-elemento-tableBalance';
  }
  public searchSubNivelBalance(item, pos){
    if(this.cuentas){
      var con = 0;
      for(var i = pos+1; i<this.dataOrdenado.length; i++){
        if(this.dataOrdenado[i].nivel > item.nivel){
          con++;
        }
        if(this.dataOrdenado[i].nivel === item.nivel || this.dataOrdenado[i].nivel < item.nivel){
          break;
        }
      }
      if(con !== 0)
        return true;
    }
    return false;
  }
  public hideShowRowBalance(item, pos){
    item.dbCheck = !item.dbCheck;
    for(var i = pos+1; i<this.dataOrdenado.length; i++){
      if(item.dbCheck){
        if(this.dataOrdenado[i].nivel === item.nivel+1){
          this.dataOrdenado[i].check = true;
        }
      }else{
        if(this.dataOrdenado[i].nivel !== item.nivel && this.dataOrdenado[i].nivel > item.nivel){
          this.dataOrdenado[i].check = false;
          this.dataOrdenado[i].dbCheck = false;
        }
      }
      if(this.dataOrdenado[i].nivel === item.nivel || this.dataOrdenado[i].nivel < item.nivel){
        break;
      }
    }
  }
  /* exportacion */
  public exportExcel(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    if(this.multiMoneda){
      headers.push(this.translate.instant('financiero.catalogoCuentas.encabezado4Tabla1'));
    }
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
    }
    let datos = [], aux = [], niveles = [];
    for(const item of this.dataOrdenado){
      niveles.push(item.nivel);
      aux.push(item?.codigo ?? item.id);
      aux.push(item.descripcion);
      if(this.multiMoneda){
        aux.push(item.moneda ?? '');
      }
      for(const val of item.series){
        aux.push(val.valor);
      }
      datos.push(aux);
      aux = [];
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per);
    }
    this.excelService.generateEstadosFinancieros(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles);
  }
  public exportExcel2(){
    let headers = [this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1')];
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.evaluacion));
    }
    let datos = [], aux = [], niveles = [];
    for(const item of this.dataOrdenado2){
      niveles.push(item.nivel);
      aux.push(item.id);
      aux.push(item.descripcion);
      for(const val of item.series){
        aux.push(val.valor);
      }
      datos.push(aux);
      aux = [];
    }
    let titulo = this.translate.instant(this.tituloTabla)+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per);
    }
    this.excelService.generateEstadosFinancieros(titulo, headers, datos, this.translate.instant(this.tituloTabla)+' '+this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles);
  }

  public capitalizacionTexto(text){
    if(!text) return;
    var mayuscula = text.substring(0,1).toUpperCase();
    if (text.length > 0) {
      var minuscula = text.substring(1).toLowerCase();
      if(minuscula[minuscula.length-1] === '.'){
        minuscula = minuscula.substring(0,minuscula.length-1);
      }
    }
    const textF = mayuscula.concat(minuscula);
    return textF;
  }
}